import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from '../types';
import { MISSING_CUSTOMER } from '@open-tender/types';
import { checkAuth, selectToken } from './account';
import { showNotification } from '../notifications';
const initialState = {
    entities: [],
    lookup: {},
    loading: 'idle',
    error: null
};
export var CustomerAddressesActionType;
(function (CustomerAddressesActionType) {
    CustomerAddressesActionType["FetchCustomerAddresses"] = "customer/fetchCustomerAddresses";
    CustomerAddressesActionType["UpdateCustomerAddresses"] = "customer/updateCustomerAddresses";
    CustomerAddressesActionType["RemoveCustomerAddress"] = "customer/removeCustomerAddress";
})(CustomerAddressesActionType || (CustomerAddressesActionType = {}));
export const fetchCustomerAddresses = createAsyncThunk(CustomerAddressesActionType.FetchCustomerAddresses, (limit, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        const { data: addresses } = yield api.getCustomerAddresses(token, limit);
        return addresses;
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
export const updateCustomerAddress = createAsyncThunk(CustomerAddressesActionType.UpdateCustomerAddresses, (data, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        yield api.putCustomerAddress(token, data.addressId, data.data);
        const limit = getState().customer.addresses.entities.length;
        const { data: addresses } = yield api.getCustomerAddresses(token, limit);
        dispatch(showNotification('Address updated!'));
        if (data.callback)
            data.callback();
        return addresses;
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
export const removeCustomerAddress = createAsyncThunk(CustomerAddressesActionType.RemoveCustomerAddress, (data, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        yield api.deleteCustomerAddress(token, data.addressId);
        const limit = getState().customer.addresses.entities.length;
        const { data: addresses } = yield api.getCustomerAddresses(token, limit);
        dispatch(showNotification('Address removed!'));
        if (data.callback)
            data.callback();
        return addresses;
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
const customerAddressesSlice = createSlice({
    name: ReducerType.CustomerAddresses,
    initialState,
    reducers: {
        resetCustomerAddresses: () => initialState,
        setCustomerAddresses: (state, action) => {
            state.entities = action.payload;
            state.error = null;
        },
        resetCustomerAddressesError: state => {
            state.error = null;
            state.loading = 'idle';
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCustomerAddresses.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchCustomerAddresses.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchCustomerAddresses.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        })
            .addCase(updateCustomerAddress.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(updateCustomerAddress.pending, state => {
            state.loading = 'pending';
        })
            .addCase(updateCustomerAddress.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        })
            .addCase(removeCustomerAddress.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(removeCustomerAddress.pending, state => {
            state.loading = 'pending';
        })
            .addCase(removeCustomerAddress.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetCustomerAddresses, setCustomerAddresses, resetCustomerAddressesError } = customerAddressesSlice.actions;
export const selectCustomerAddresses = (state) => state.customer.addresses;
export const customerAddressesReducer = customerAddressesSlice.reducer;
